<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>트링카 통합 지원
                            <span>(기업전용)</span>
                        </h1>
                        <p style="margin: 0 0 0 0;">기업전용인 트링카 엔터프라이즈는 작업 흐름에 따라 모든
                            <br />기능을 통합하여 트링카를 좀 더 쉽게 접근하여 사용 할 수 </p>
                        <p>있도록 지원합니다.</p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit" style="width: 190px;">문의 하기</button>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/enterprise_banner_img.png" alt="banner">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>글로벌
                        <br>사용자
                    </h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="clients">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/UNSW.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="clients">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="clients">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="other_comparision">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>영문작성 향상을 위한 기업 맞춤형 솔루션</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 고객님의 팀이 전문 문서를 효율적으로 작성하는 동시에 품질과 일관성을 보장할 수 있도록 지원합니다.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>생명과학, 의학 및 제약</h3>
                        </div>
                        <p>트링카의 강력한 AI는 의학 및 과학 글쓰기에 필요한 기술적 복잡성과 정확성을 이해합니다. 트링카는 해당 맥락과 주제에 맞는 제안을 해드립니다.
                        </p>
                        <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">더 읽어보기
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>언어 서비스, 출판 및 미디어</h3>
                        </div>
                        <p>팀이 일관성을 유지하는 글을 쓰고 이를 더 빠르게 출판하여 고객 경험을 향상할 수 있습니다. 품질을 유지하면서도 글쓰기에 드는 시간과 비용을 줄여보세요.</p>
                        <a [routerLink]="['/enterprise/language-services-publishing-and-media']">더 읽어보기
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>교육기관</h3>
                        </div>
                        <p>트링카는 학술적 글쓰기의 규칙과 모범 사례에 맞게끔 글을 다듬어 출판 준비를 도와드립니다.</p>
                        <a [routerLink]="['/enterprise/academic-institutions']">더 읽어보기
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>K-12 및 E-러닝</h3>
                        </div>
                        <p>트링카의 선진 AI는 학생들이 글쓰기를 향상시킬 뿐만 아니라 모범적인 학술적 글쓰기 관행을 배우는데 도움이 됩니다.</p>
                        <a [routerLink]="['/enterprise/k12-and-elearning']">더 읽어보기
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>기술 플랫폼</h3>
                        </div>
                        <p>트링카를 사용하면 애플리케이션 내에서 실시간 글쓰기 지원을 쉽게 추가할 수 있습니다. 트링카의 글쓰기 제안을 제공하여 고유한 솔루션을 구축해 보세요.</p>
                        <a [routerLink]="['/enterprise/technology-platforms']">더 읽어보기
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>트링카와 통합하는 3가지 방법</h2>
                        <div class="HeadingSubLine"></div>
                        <p>모든 팀의 글쓰기 수준을 높여줍니다. 기업 사용자들은 무제한 접근 및 다양한 혜택이 제공됩니다. 사용자의 필요에 따라 알맞은 통합 옵션을
                            <br /> 선택할 수 있습니다.</p>
                    </div>
                </div>
            </div>
            <div class="row divider_line_section">
                <div class="col-lg-5">
                    <div class="integreate_img_section GetTrinkaJs_img">
                        <img class="getTrinkajs_gif_img" src="../../../assets/images/GetTrinkaJs.gif" alt="tinka-js">
                        <img class="getTrinkaJs_backgrond" src="../../../assets/images/API_backgrond_layer.png" alt="api-bg">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>01</span> 트링카
                            <b style="padding: 0px 12px 4px 12px;">JS</b> (자바스크립트)</h3>
                        <p>브라우저 또는 어플리케이션에 자바스크립트 코드 조각을 삽입하면 팀원 모두 함께
                            <br /> 트링카를 이용할 수 있습니다. 복잡한 통합 절차 없이 트링카를 설치하여 간단하고
                            <br /> 손쉽게 모든 기능을 사용하세요.</p>
                        <ul>
                            <li>
                                <h4>간편 통합</h4>
                                <p>작은 자바스크립트 조각을 애플리케이션에 삽입하면 사용자들이 함께
                                    <br />트링카를 통해 더 좋은 글쓰기를 시작할 수 있습니다.</p>
                            </li>
                            <li>
                                <h4>보안</h4>
                                <p>모든 데이터는 강도높게 암호화되어 있습니다. 트링카 자바스크립트는
                                    <br />실시간으로 작동하며 서버에는 저장되지 않습니다.</p>
                            </li>
                            <li>
                                <h4>탁월한 유연성</h4>
                                <p>사용이 간편한 JS 조각 덕분에 통합하기 쉽고 동시에 탄력적입니다.
                                    <br />팀이나 기업의 성장에 따라 쉽게 확장할 수 있습니다.</p>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>

            <div class="row divider_line_section columu_reverse">
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>02</span> 트링카
                            <b>API</b>
                        </h3>
                        <p>제품 내에 트링카를 연동하고 싶으신가요? 트링카의 강력한 API는 어떤
                            <br />어플리케이션에도 쉽게 설치 할 수 있습니다. 사용하기 쉬운 트링카 API는 높은
                            <br /> 안정성과 확장성을 제공합니다.</p>
                        <ul>
                            <li>
                                <h4>특화된 API</h4>
                                <p>트링카 API는 서비스 가용성이 높아 필요할때 언제든지 도움 받을 수 있습니다.</p>
                            </li>
                            <li>
                                <h4>맞춤형 API</h4>
                                <p>어플리케이션에서나만의 트링카 API 연동이 필요한가요? 문의주세요.
                                    <br /> 트링카 API는 사용자 맞춤형으로 가능합니다.</p>
                            </li>
                            <li>
                                <h4>탁월한 유연성</h4>
                                <p>특화된 API는 사용하기 쉬움과 동시에 탄력적입니다. 트링카는 사용하는
                                    <br /> 제품 규모에 맞춰 규모를 조절합니다.</p>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_API">
                        <img class="API_bg_layer" src="../../../assets/images/API_backgrond_layer.png" alt="layers">
                        <img class="TrinkaAPI_img" src="../../../assets/images/TrinkaAPI_img.png" alt="api">
                        <div class="API_text_section" data-aos="zoom-in">
                            <span></span>
                            <div class="API_text_overlay"></div>
                            <img src="../../../assets/images/API_text.png" alt="API">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_on_premise">
                        <img src="../../../assets/images/GetTrinkaOn_Premise.png" alt="On-Premise">
                        <span class="TrinkaPurpleColor"></span>
                        <span class="TrinkaredColor"></span>
                        <span class="TrinkaYellowColor"></span>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>03</span> 트링카
                            <b>On-Premise</b>
                        </h3>
                        <p>고도로 민감한 데이터로 작업하시나요? 그렇다면 트링카 On-Premise가 최고의
                            <br /> 솔루션입니다. 기업 인프라에 트링카를 설치하여 작업해 보세요.</p>
                        <ul>
                            <li>
                                <h4>전담 지원</h4>
                                <p>트링카 On-Premise를 사용할 경우, 전담 서비스 담당자가 고객님의 IT 팀과
                                    <br />협업하여 간편하게 통합할 수 있습니다.
                                </p>
                            </li>
                            <li>
                                <h4>보안</h4>
                                <p>트링카 AI가 귀사의 인프라 내에서 작동하므로 데이터의 보안은 완벽합니다.</p>
                            </li>
                            <li>
                                <h4>탁월한 유연성</h4>
                                <p>쉬운 통합과 전담 지원 서비스로, 트링카는 기업 내 팀이나 사업 성장에 맞춰
                                    <br /> 손 쉽게 확장할 수 있습니다.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="enterprise_contactUs">
        <p>맞춤형 견적을 받아보세요</p>
        <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
            class="plansButtons" type="submit">데모 요청</button>
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>